export enum Permission {
  AccountCanManage = 'Account:CanManage',
  AudienceAllResourcesManage = 'Audience:AllResources_Manage',
  AUAccountAdminRoleCanManage = 'AU.AccountAdminRole.CanManage',
  AudienceAccountCreate = 'audience:allresources:manage',
  AllResourcesManage = 'allresources:manage',
  CoreAudienceAccountCreate = 'core:Audience:Account_Create',
  CanSwitch = 'CanSwitch',
  CanManage = 'CanManage',
  PreLaunch = 'PreLaunch',
  CanLogin = 'au:backoffice:login',
  CanRead = 'au:data:read',
  CanPlaceOrders = 'au:order:write',
  CanCreateAccount = 'audience:account:create',
  CanDeleteAccount = 'au:account:remove',
  CanAddStaff = 'au:staff:write',
  CanInviteStaff = 'au:staff:invite',
  CanInvitePartner = 'au:partner:invite',
  CanRequestInvitationLink = 'au:invitationlink:generate',
  CanUpdateRole = 'au:role:write',
  CanWriteEmailTemplate = 'email:template:write',
  CanAddSU = 'au:rolesu:write',
  CanManageSenderDomain = 'email:senderdomain:manage',
  CanWriteEmailBootstrap = 'email:bootstrap:write',
  CanCreateCrmKeyspace = 'au:crm-keyspace:write',
  WawBackOfficePreLaunch = 'waw:backoffice:prelaunch',
  CanUseConsent2Migration = 'au:backoffice:consent2migration',
  WawPrivateDomainRead = 'waw:privatedomain:read',
  WawPrivateDomainWrite = 'waw:privatedomain:write',
  TransactionalTeamBackOfficePreLaunch = 'transactional-team:backoffice:prelaunch',
  TransactionalTeamTransactionalRead = 'transactional-team:transactional:read',
  TransactionalTeamTransactionalWrite = 'transactional-team:transactional:write',
  CanCreateTrialAccount = 'au:trialaccount:create',
}
